import * as yup from 'yup'
import Translations from '../../../translations'
import { translate } from '../../../base/localization'
import { RESELLER_MAX_LENGTH } from '../../../base/utils/resellerRule'
// const FILE_SIZE = 19201212121;
// const SUPPORTED_FORMATS = [
//   "image/jpg",
//   "image/jpeg",
//   "image/gif",
//   "image/png"
// ];
const t = translate(Translations)
const validations = yup.object().shape({
  Email: yup
    .string()
    .email('Geçerli bir email adresi girmelisiniz!')
    .nullable()
    .min(5, 'En az 5 karakter girilmelidir!')
    .max(40, 'En fazla 40 karakter girilmelidir!')
    .required('Lütfen email alanını doldurunuz!'),
  TaxOrTcNumber: yup
    .string()
    .nullable()
    .min(10, 'En az 10 karakter girilmelidir!')
    .max(11, 'En fazla 11 karakter girilmelidir!')
    .required('Lütfen T.C. veya Vergi numarası giriniz!'),
  NameAndSurname: yup
    .string()
    .min(5, 'En az 5 karakter girilmelidir!')
    .max(35, 'En fazla 35 karakter girilmelidir!')
    .required('Lütfen adı soyadı alanını doldurunuz!'),
  Unvan: yup
    .string()
    .min(5, 'En az 5 karakter girilmelidir!')
    .max(35, 'En fazla 35 karakter girilmelidir!')
    .required('Lütfen Yetkili İsmi alanını doldurunuz!'),
  Phone: yup
    .string()
    .test('len', 'Telefon numarası 10 karakter olmalı!', val => {
      const a = val
        ?.replaceAll('_', '')
        .replaceAll('-', '')
        .replaceAll('(', '')
        .replaceAll(' ', '')
        .replaceAll(')', '').length
      return a === 10
    })
    .nullable()
    .required('Lütfen telefon alanını doldurunuz!'),
  AddressDetail: yup
    .string()
    .min(5, 'En az 5 karakter girilmelidir!')
    .max(40, 'En fazla 40 karakter girilmelidir!')
    .required('Lütfen adres giriniz!'),
  AddressDetail2: yup
    .string()
    .max(40, 'En fazla 40 karakter girilmelidir!')
    .nullable(),
  // Reseller bu sayfada zorunlu degildir; yalnizca SAP PURCH_NO_S sahasinin uzunlugu ile sinirlidir.
  Reseller: yup
    .string()
    .max(RESELLER_MAX_LENGTH, `En fazla ${RESELLER_MAX_LENGTH} karakter girilmelidir!`)
    .nullable(),
  AddressTitle: yup
    .string()
    .min(5, 'En az 5 karakter girilmelidir!')
    .max(40, 'En fazla 40 karakter girilmelidir!')
    .required('Lütfen adres başlığı giriniz!'),
  Country: yup.string().required('Lütfen ülke seçiniz!'),
  City: yup.string().required('Lütfen il seçiniz!'),
  District: yup.string().required('Lütfen ilçe seçiniz!'),
  PostCode: yup.string().required('Lütfen Mahalle seçiniz!'),
})

export default validations
//TODO GSM EMAİL REGEX ADDED
